import { API_BASE_URL, getAuthHeaders } from '../../../../utils/utils';

const BOOST_STATUS_CACHE_TTL_MS = 5 * 60 * 1000;

const boostStatusCache = new Map();
const boostStatusInFlight = new Map();

const getBoostStatusCacheKey = (userEmail) =>
  String(userEmail || '').trim().toLowerCase();

export async function fetchBoostStatus(userEmail, { forceRefresh = false } = {}) {
  if (!userEmail) {
    return null;
  }

  const cacheKey = getBoostStatusCacheKey(userEmail);
  const cached = boostStatusCache.get(cacheKey);
  const now = Date.now();

  if (
    !forceRefresh &&
    cached &&
    now - cached.fetchedAt < BOOST_STATUS_CACHE_TTL_MS
  ) {
    return cached.payload;
  }

  const existingInFlight = boostStatusInFlight.get(cacheKey);
  if (existingInFlight) {
    return existingInFlight;
  }

  const request = (async () => {
    const response = await fetch(`${API_BASE_URL}/api/gre/boost-status`, {
      method: 'GET',
      headers: getAuthHeaders(),
    });

    if (!response.ok) {
      if (response.status === 401) {
        throw new Error('Authentication failed');
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const payload = await response.json();
    boostStatusCache.set(cacheKey, {
      payload,
      fetchedAt: Date.now(),
    });
    return payload;
  })();

  boostStatusInFlight.set(cacheKey, request);

  try {
    return await request;
  } finally {
    boostStatusInFlight.delete(cacheKey);
  }
}

export function clearBoostStatusCache(userEmail = null) {
  if (!userEmail) {
    boostStatusCache.clear();
    boostStatusInFlight.clear();
    return;
  }

  const cacheKey = getBoostStatusCacheKey(userEmail);
  boostStatusCache.delete(cacheKey);
  boostStatusInFlight.delete(cacheKey);
}
